import script from "./RecognizerDemoView.vue?vue&type=script&setup=true&lang=js"
export * from "./RecognizerDemoView.vue?vue&type=script&setup=true&lang=js"

import "./RecognizerDemoView.vue?vue&type=style&index=0&id=89faa834&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89faa834"]])

export default __exports__